var GuestUpsell = function() {

    var i,p; // i = item identifier, p = product type

    var _init = function(){

        GuestUpsell.watch();
        
        //paint a default login form with no data about the item or product type
        GuestUpsell.loginForm({i:i,p:p});

        $('#auth-tabs-free a[data-toggle="tab"]').on('show.bs.tab',function(){
            $('.legals-collapse').collapse('hide');
            if( $(this).attr('href') == '#auth-tab-login-free' ){
                GuestUpsell.loginForm({i:i,p:p});
                $('#present-card').addClass('d-none');
            }else{
                GuestUpsell.registerForm({i:i,p:p});
            }
        });

        $('#modal-shop-tabbed-auth').on('shown.bs.modal',function(e){
            setTimeout(function(){
                i = $(e.relatedTarget).data('i');
                p = $(e.relatedTarget).data('p');
                $('#login-form').find('input[name="i"]').val(i);
                $('#login-form').find('input[name="p"]').val(p);
                Debug.log('shown.bs.modal for '+p, i);
                Debug.log($('#modal-login-form').find('input[name="p"]').val());
            },200);
        });    

    }

    var _watch = function( content ){

        $('.promana-add-cart').off().on('click', function(){
            Do.Ajax(ecomConf.route.add,{
                p:$(this).data('p'),
                i:$(this).data('i'),
            });
            Debug.log('GuestUpsell: promana-add-cart clicked');
            // $('#subscription-flow').removeClass('d-none');
        });

        $('#register-next-free').on('click', function(){
            var form = $('#modal-reg-form').serializeJSON();
            Do.Ajax('/auth/register',{
                form: form,  
                i: i,
                p: p,  
            });
        });

    }

    var _loginForm = function( response ){
        Do.Ajax('/auth/loginform',{
            s: 1, 
            p: response?.p, 
            i: response?.i, 
        });
    }
    
    var _regForm = function( response ){
        Do.Ajax('/auth/regform',{
            s: 1, 
            p: response?.p, 
            i: response?.i, 
        })
    }

    var _auth = function( response ){
        Debug.log('GuestUpsell: auth response', response);
        GuestUpsell.loginForm(response);
        i = response?.i;
        p = response?.p;
    }

    return {
        init: function() {
            _init();
        },
        watch: function( c ){
            _watch( c );
        },
        modalAuth: function( r ){
            _auth( r );
        },
        loginForm: function(r){
            _loginForm(r);
        },
        registerForm: function(r){
            _regForm(r);
        },
        paint: function(r){
            p=r?.p;
            i=r?.i;
            $(r.f).html(r.elements);
            Debug.log('GuestUpsell: paint', r);
            if( r.a ){
               Auth.awaitLogin($(r.a))
            }
        },
        shopOrCart: function( r ){
            setTimeout(function(){
                $('.auth-succeeded').removeClass('d-none').addClass('d-block');
                $('.auth-succeeded-next').html(r.cta).show();
                $('.auth-succeeded-flash').text(r.flash).show().delay(5000).fadeOut('slow');
                $('#modal-onetime-form').empty();
                Debug.log('GuestUpsell: shopOrCart', r);
                Debug.log($('.auth-succeeded'));
            },200);
        }
    }

}();